export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/identity.js
// module id = 104
// module chunks = 0